import { useSearchParams } from "react-router";
import { settings } from "./settings/settings";

export const useFeatureEnabled = (key: string): boolean => {
	const [searchParams] = useSearchParams();

	if (settings.features[key as keyof typeof settings.features]) {
		return true;
	}
	const features = JSON.parse(
		window.sessionStorage.getItem("features") ?? "{}",
	);
	if (features[key]) {
		return true;
	}
	if (searchParams.get(key) !== "true") {
		return false;
	}
	features[key] = true;
	window.sessionStorage.setItem("features", JSON.stringify(features));
	return true;
};

export const isEnabledDriftForecast = () => {
	return useFeatureEnabled("enableDriftForecast");
};

export const isEnabledHolders = () => {
	return useFeatureEnabled("enableHolders");
};

export const isEnabledEarningsAnalysis = () => {
	return useFeatureEnabled("enableEarningsAnalysis");
};

export const isEnabledBacktest = () => {
	return useFeatureEnabled("enableBacktest");
};

export const isEnabledElements = () => {
	return useFeatureEnabled("enableElements");
};

export const isEnabledAccountPage = () => {
	return useFeatureEnabled("enableAccountPage");
};

export const isEnabledProfilePage = () => {
	return useFeatureEnabled("enableProfilePage");
};

export const isEnabledAdvancedChart = () => {
	return useFeatureEnabled("enableAdvancedChart");
};

export const isEnabledQuote = () => {
	return useFeatureEnabled("enableQuote");
};

export const isEnabledChat = () => {
	return useFeatureEnabled("enableChat");
};

export const isEnabledScorer = () => {
	return useFeatureEnabled("enableScorer");
};
